export default function BannerPrincipal() {
  return (
    <section style={{ 
      textAlign: 'center', 
      padding: '8rem 2rem', 
      background: 'linear-gradient(135deg, var(--black) 0%, var(--dark-gray) 100%)',
      borderBottom: '1px solid var(--accent)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Elemento decorativo */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.03) 0%, transparent 60%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        <img
          src="/assets/Marca d_água/PNG/MARCA D_ÁGUA.png"
          alt="Logo"
          width={180}
          style={{ 
            marginBottom: '2.5rem',
            filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2))'
          }}
        />
        
        <h1 style={{ 
          fontSize: 'clamp(2.2rem, 6vw, 3.5rem)',
          marginBottom: '1.8rem',
          color: 'var(--white)',
          fontWeight: '700',
          letterSpacing: '0.5px',
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
        }}>
          <span style={{
            color: 'rgba(255, 255, 255, 0.75)',
            fontWeight: '400'
          }}>Paulo Ferreira &</span> Maike Ramos
        </h1>
        
        <p style={{ 
          fontSize: 'clamp(1.1rem, 2.2vw, 1.4rem)',
          maxWidth: '700px',
          margin: '0 auto 3rem',
          color: 'var(--text-color)',
          lineHeight: '1.5',
          letterSpacing: '0.5px'
        }}>
          Advocacia Trabalhista especializada
        </p>
        
        <a 
          href="https://tintim.link/whatsapp/f29b407c-6594-4bba-b0aa-f5442f711a68/e7405481-419a-4fdb-8030-9aee45f67a3a"
          target="_blank"
          rel="noreferrer"
          style={{
            padding: 'clamp(0.75rem, 2vw, 1rem) clamp(2rem, 4vw, 3rem)',
            fontSize: 'clamp(0.95rem, 2vw, 1.15rem)',
            fontWeight: '600',
            background: '#25D366',
            color: 'var(--white)',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            position: 'relative',
            overflow: 'hidden',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(37, 211, 102, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
          }}
        >
          <i className="fab fa-whatsapp" style={{ fontSize: '1.2em' }}></i>
          WhatsApp
          <span style={{
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
            animation: 'buttonShine 3s infinite'
          }}></span>
        </a>
        
        <style jsx>{`
          @keyframes buttonShine {
            0% { left: -100%; }
            20% { left: 100%; }
            100% { left: 100%; }
          }
        `}</style>
      </div>
    </section>
  )
}